import React, { useState, useEffect } from 'react';
import UIInput from '@/components/shared/UIInput';
import UIButton from '@/components/shared/UIButton';
import './DocumentsSearchForm.scss';

interface DocumentsSearchFormProps {
  onSearch: (searchQuery: string) => void;
  isLoading?: boolean;
}

const DocumentsSearchForm: React.FC<DocumentsSearchFormProps> = ({
  onSearch,
  isLoading = false,
}) => {
  const [searchQuery, setSearchQuery] = useState('');

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchQuery(event.target.value);
  };

  const handleSearch = () => {
    onSearch(searchQuery);
  };

  return (
    <div className="DocumentsSearchForm">
      <div className="DocumentsSearchForm__controls">
        <UIInput
          value={searchQuery}
          onChange={handleInputChange}
          placeholder="Search documents..."
          className="DocumentsSearchForm__input"
          onKeyDown={(e) => e.key === 'Enter' && handleSearch()}
          fullWidth
        />
      </div>
      <div className="DocumentsSearchForm__actions">
        <UIButton onClick={handleSearch} variant="primary" disabled={isLoading}>Search</UIButton>
      </div>
    </div>
  );
};

export default DocumentsSearchForm;
